// extracted by mini-css-extract-plugin
module.exports = {"title":"ModalTitle_title__2P7Ji"};